import { SharedQueryParamKey } from '@ddt-web/url';

export class PortfolioIdResolverUtil {
	public static getPortfolioIds(qsSearchParams: URLSearchParams): string {
		let portfolioIds: string = null;
		if (qsSearchParams && qsSearchParams.has('portfolios')) {
			portfolioIds = qsSearchParams.get(SharedQueryParamKey.PORTFOLIOS).replace('list,', '');
		}
		return portfolioIds;
	}

	/**
	 * The portfolios query param can either be a list of strings or a string.
	 * This method helps us get the comma-separated list of portfolios as a string, without the 'list,' prefix
	 * @param queryParams the queryParams as they come from the UrlService
	 * @returns a comma-separated list of portfolio ids
	 */
	public static getPortfolioIdsFromQueryParams(queryParams: { [key: string]: any }): string {
		const portfolioIds: string = queryParams?.[SharedQueryParamKey.PORTFOLIOS] ?? null;
		if (typeof portfolioIds !== 'string' && !!portfolioIds?.['length']) {
			return (portfolioIds as string[]).join(',');
		}
		return portfolioIds;
	}

	public static getEngagementId(qsSearchParams: URLSearchParams): string {
		let engagementId: string = null;
		if (qsSearchParams && qsSearchParams.has(SharedQueryParamKey.ENGAGEMENT)) {
			engagementId = qsSearchParams.get(SharedQueryParamKey.ENGAGEMENT);
		}
		return engagementId;
	}
}
